export default {
  "content": "<path fill=\"#707070\" fill-rule=\"evenodd\" d=\"M32.5 5.29C17.748 5.29 5.79 17.247 5.79 32S17.747 58.71 32.5 58.71c10.516 0 19.617-6.075 23.975-14.92a2.645 2.645 0 114.745 2.338C56.005 56.71 45.106 64 32.5 64 14.827 64 .5 49.673.5 32c0-17.673 14.327-32 32-32 12.834 0 23.898 7.555 28.997 18.45a2.645 2.645 0 01-4.79 2.241C52.444 11.587 43.204 5.29 32.5 5.29z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "62",
    "height": "64",
    "fill": "none",
    "viewBox": "0 0 62 64"
  }
};